import React from 'react'
import '../static/css/style.css'
import Map from './Map.js'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import Loader from 'react-loader-spinner'
import holidays from '../static/imgs/happy-holidays.png'
import logo from '../static/imgs/tm-logo-grey.png'

import {
  useParams,
  Redirect
} from 'react-router-dom'

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon
} from 'react-share'

function Card (props) {
  let { long, lat, hash } = useParams()
  const [iso, setIso] = React.useState({
    30: [200, 46, 39],
    15: [250, 208, 87],
    5: [250, 208, 87]
  })

  const [level, setLevel] = React.useState({
    5: [248, 234, 179],
    4: [244, 218, 63],
    3: [205, 102, 50],
    2: [177, 44, 36],
    1: [240, 76, 46]
  })
  const [msg, setMsg] = React.useState({ 'to': null, 'from': null, 'message': null })
  const [loading, setLoading] = React.useState(false)
  const [pindrop, setPindrop] = React.useState(false)
  const [home, setHome] = React.useState(false)
  const [url, setUrl] = React.useState('')
  const handlePindrop = (setting) => {
    setPindrop(setting)
  }

  const handleLoading = (setting) => {
    setLoading(setting)
  }

  React.useEffect(() => {
    setHome(false)
    setUrl('https://isochrone-holiday-cards.web.app/' + long + '/' + lat + '/' + hash)
  }, [])
  React.useEffect(() => {
    if (!hash) {
      return
    }

    let url = 'https://storage.googleapis.com/tm-christmais/iso-christmais/metadata/' + hash + '.json'
    fetch(url).then(res => res.json()).then((result) => {
      setMsg(result)
    })
  }, [])

  return (
    home
      ? <Redirect exact to='/' />
      : <div className='card-page'>
        <div className='christmas-card'>
          <div className='map-group'>
            <div className='loader' style={{ visibility: loading ? 'visible' : 'hidden' }}>
              <Loader
                type='ThreeDots'
                color='#ef4631'
                height={50}
                width={50}
              />
              <h4> Loading traffic data... </h4>
            </div>
            <div className='map-container'>
              <Map
                levelColors={level}
                isoColors={iso}
                handleLoading={handleLoading}
                handlePindrop={handlePindrop}
              />
            </div>
          </div>
          <div className='message'>
            <img className='holidays' src={holidays} />
            <h3> Dear {msg['to']}, </h3>
            <p> <pre>{msg['message']}</pre> </p>
            <h3> {msg['from']} </h3>
            <img className='logo' src={logo} />
            <p className='subtext'> The artwork on the cover is an isochrone; a shape around your office which represents the reachable area within 5, 15, adn 30 minutes by walking. Every journey starts with a single step; we hope that the new year will serve as the first step in your journey to create an even larger impact this decade to come. </p>
          </div>
        </div>
        <div className='share-link'>
          <div>
            <FacebookShareButton
              url={url}
              quote={'Checkout this personalized Geospatial Christmas Cards from Thinking Machines!'}
            >
              <FacebookIcon
                size={24}
                round />
            </FacebookShareButton>
          </div>
          <div>
            <TwitterShareButton
              url={url}
              title={'Checkout this personalized Geospatial Christmas Cards from Thinking Machines!'}
            >
              <TwitterIcon
                size={24}
                round />
            </TwitterShareButton>
          </div>
          <div>
            <LinkedinShareButton
              url={url}
              title={'Checkout this personalized Geospatial Christmas Cards from Thinking Machines!'}
            >
              <LinkedinIcon
                size={24}
                round />
            </LinkedinShareButton>
          </div>
          <button className='home-button' onClick={() => setHome(true)}>
          Make More Cards!
          </button>
        </div>
      </div>
  )
}

export default Card
